import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Button, Stack, TextField } from "@mui/material";
import { OssPanel } from "../common/OssPanel";

export const OssReportFilter = ({ from, to, onChange, onSearch, onDownload }) => (
  <OssPanel sx={{ p: 1.5 }}>
    <Stack direction={{ xs: "column", md: "row" }} spacing={1} alignItems={{ xs: "stretch", md: "center" }}>
      <TextField size="small" type="date" label="시작일" InputLabelProps={{ shrink: true }} value={from} onChange={(e) => onChange("from", e.target.value)} />
      <TextField size="small" type="date" label="종료일" InputLabelProps={{ shrink: true }} value={to} onChange={(e) => onChange("to", e.target.value)} />
      <Button variant="contained" startIcon={<SearchRoundedIcon />} onClick={onSearch}>
        조회
      </Button>
      <Button variant="outlined" startIcon={<DownloadRoundedIcon />} onClick={onDownload}>
        CSV 다운로드
      </Button>
    </Stack>
  </OssPanel>
);
